import { useEffect } from 'react';
import { useState } from 'react';
import CurrencyInput from 'react-currency-input-field';


export const SBACurrencyInput = ({ value, onValueChange , onBlur, decimalsLimit,groupSeparator, className,  ...props }) => {
  const [val, setVal] = useState(value);
  const Class=className ? className :'';



  useEffect(() => {
    setVal(value);
  }, [value]);

  const handleChange = (value, name, values) => {
    setVal(value);
    if (onValueChange) {
      onValueChange(values.float)
    }
  };

  const handleBlur = (e) => {
    if (onBlur) {
      const value=e.target.value.replaceAll(',','');
      onBlur(value);
    }
  };

  return <CurrencyInput
    value={val}
    className={`form-control ${Class}`}
    defaultValue={val}
    decimalsLimit={decimalsLimit}
    onValueChange={handleChange}
    onBlur={handleBlur}
    {...props}
  />
}